import { ComponentProps } from "react";

interface Props extends ComponentProps<"svg"> {
  width: string;
  height: string;
}

const IrelandIcon = ({ width, height }: Props) => {
  return (
    <div>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_332_181)">
          <path
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            fill="#F0F0F0"
          />
          <path
            d="M22 12C22 7.70043 19.2863 4.03496 15.4783 2.62207V21.3781C19.2863 19.9651 22 16.2997 22 12Z"
            fill="#FF883E"
          />
          <path
            d="M2 12C2 16.2997 4.71375 19.9651 8.52176 21.3781V2.62207C4.71375 4.03496 2 7.70043 2 12Z"
            fill="#169B62"
          />
        </g>
        <defs>
          <clipPath id="clip0_332_181">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default IrelandIcon;
